import { Categoria } from '../types';

export type CategoriaPlantilla = Omit<Categoria, 'id' | 'usuarioId'>;

/**
 * Categorías que se ofrecen para empezar. No se crean solas: el usuario elige
 * cuáles quiere desde Configuración → Categorías → «Desde plantilla».
 * Cambiar esta lista no toca las categorías que ya tenga nadie.
 */
export const CATEGORIAS_PLANTILLA: CategoriaPlantilla[] = [
  // ── Gastos ──────────────────────────────────────────────────────────────
  { tipo: 'gasto', nombre: 'Vivienda',             icono: '🏠', color: '#3B82F6' },
  { tipo: 'gasto', nombre: 'Suministros',          icono: '💡', color: '#F59E0B' },
  { tipo: 'gasto', nombre: 'Internet y teléfono',  icono: '📱', color: '#06B6D4' },
  { tipo: 'gasto', nombre: 'Supermercado',         icono: '🛒', color: '#10B981' },
  { tipo: 'gasto', nombre: 'Restaurantes',         icono: '🍽️', color: '#F97316' },
  { tipo: 'gasto', nombre: 'Transporte',           icono: '🚗', color: '#6366F1' },
  { tipo: 'gasto', nombre: 'Combustible',          icono: '⛽', color: '#EF4444' },
  { tipo: 'gasto', nombre: 'Salud',                icono: '💊', color: '#14B8A6' },
  { tipo: 'gasto', nombre: 'Seguros',              icono: '🛡️', color: '#8B5CF6' },
  { tipo: 'gasto', nombre: 'Ropa y calzado',       icono: '👕', color: '#EC4899' },
  { tipo: 'gasto', nombre: 'Cuidado personal',     icono: '💈', color: '#D946EF' },
  { tipo: 'gasto', nombre: 'Hogar',                icono: '🛋️', color: '#84CC16' },
  { tipo: 'gasto', nombre: 'Ocio',                 icono: '🎬', color: '#F97316' },
  { tipo: 'gasto', nombre: 'Viajes',               icono: '✈️', color: '#06B6D4' },
  { tipo: 'gasto', nombre: 'Suscripciones',        icono: '📺', color: '#6366F1' },
  { tipo: 'gasto', nombre: 'Educación',            icono: '📚', color: '#3B82F6' },
  { tipo: 'gasto', nombre: 'Mascotas',             icono: '🐾', color: '#84CC16' },
  { tipo: 'gasto', nombre: 'Regalos',              icono: '🎁', color: '#EC4899' },
  { tipo: 'gasto', nombre: 'Impuestos',            icono: '🏛️', color: '#EF4444' },
  { tipo: 'gasto', nombre: 'Comisiones bancarias', icono: '🏦', color: '#8B5CF6' },
  { tipo: 'gasto', nombre: 'Otros gastos',         icono: '📦', color: '#F59E0B' },

  // ── Ingresos ────────────────────────────────────────────────────────────
  { tipo: 'ingreso', nombre: 'Nómina',             icono: '💼', color: '#10B981' },
  { tipo: 'ingreso', nombre: 'Trabajos extra',     icono: '🧾', color: '#14B8A6' },
  { tipo: 'ingreso', nombre: 'Ventas',             icono: '🏷️', color: '#06B6D4' },
  { tipo: 'ingreso', nombre: 'Rendimientos',       icono: '📈', color: '#3B82F6' },
  { tipo: 'ingreso', nombre: 'Alquileres',         icono: '🔑', color: '#8B5CF6' },
  { tipo: 'ingreso', nombre: 'Reembolsos',         icono: '↩️', color: '#84CC16' },
  { tipo: 'ingreso', nombre: 'Regalos recibidos',  icono: '🎁', color: '#EC4899' },
  { tipo: 'ingreso', nombre: 'Otros ingresos',     icono: '💰', color: '#F59E0B' },
];

/** Clave para reconocer una categoría ya creada: mismo tipo y mismo nombre, sin mayúsculas. */
export const claveCategoria = (c: { tipo: string; nombre: string }) =>
  `${c.tipo}:${c.nombre.trim().toLowerCase()}`;

/**
 * Las que vienen marcadas en el plan gratis, que tiene un tope de categorías
 * (LIMITES_GRATIS.categorias): lo justo para empezar, dejando hueco libre.
 */
export const CATEGORIAS_BASICAS = new Set([
  'Vivienda', 'Suministros', 'Internet y teléfono', 'Supermercado', 'Restaurantes', 'Transporte',
  'Salud', 'Ocio', 'Otros gastos', 'Nómina', 'Reembolsos', 'Otros ingresos',
]);
